import {dynamicRoutes,adminRoutes} from './routes'
import store from '@store'

//根据权限获取路由
export function getPermissionRoutes(permissionList) {
  let routes = permissionList.length ? generatePermissionRoutes(dynamicRoutes, permissionList) : dynamicRoutes;
  +store.state.isAdmin === 1 && (routes = routes.concat(adminRoutes));
  routes[0] && (routes[0].path = "/index");
  //父元素默认重定向第一个子元素
  setDefaultRedirect(routes);
  return routes;
}

function generatePermissionRoutes(routes, permissionList) {
  let list = [];
  routes.forEach(route => {
    if (hasPermission(route, permissionList)) {
      let newRoute = {...route};
      newRoute.children && (newRoute.children = generatePermissionRoutes(newRoute.children, permissionList));
      list.push(newRoute);
    }
  });
  return list;
}

//获取树形结构
export function getRoutesTree(permissionList) {
  return generateTree(dynamicRoutes, permissionList);
}

function generateTree(routes, permissionList) {
  let list = [];
  routes.forEach(route => {
    let permission = hasPermission(route, permissionList);
    if (permission) {
      let tree = {
        label: route?.meta?.title,
        icon: route?.meta?.icon,
      };
      if (route.children && route?.meta?.subMenu) {
        tree.children = generateTree(route.children, permissionList)
      } else if (route.children) {
        let childRoute = route.children[0];
        tree.label = childRoute.meta?.title;
        tree.icon = childRoute.meta?.icon;
        tree.value = childRoute.meta?.permission[0];
        tree.permissionId = permission.id;
      } else {
        tree.value = route?.meta?.permission[0];
        tree.permissionId = permission.id;
      }
      list.push(tree);
    }
  });
  return list;
}

//判断权限
function hasPermission(route, permissionList) {
  if (!permissionList) return true;
  let routePermission = route?.meta?.permission || [];
  return permissionList.find(permission => routePermission.includes(permission.name || permission));
}

//获取所有动态路由
export function getDynamicRoutes() {
  return generateDynamicRoutes(dynamicRoutes);
}

function generateDynamicRoutes(routes) {
  let list = [];
  routes.forEach(item => {
    if (item.children) {
      list = list.concat(generateDynamicRoutes(item.children));
    } else {
      list.push({
        id: item?.meta?.permission[0] || "",
        msg: item?.meta?.title || ""
      });
    }
  });
  return list;
}

//父元素默认跳转第一个子元素
function setDefaultRedirect(routes) {
  routes.forEach(route => {
    if (route?.children?.length) {
      let children = route.children.find(item => !item.hidden);
      children && (route.redirect = children.path);
      setDefaultRedirect(route.children)
    }
  });
}


